export default function PersonalWebsiteTryIt() {
  return (
    <div className="tryit-personal">
      <p>Jump to the Work list on this page and open any project.</p>
      <a href="#work" data-testid="tryit-personal-website-cta" className="tryit-cta">
        Go to Work →
      </a>
    </div>
  )
}
